import { MAINTENANCE_AGING, type MaintenanceAging } from '../buildingManagementTypes';

/**
 * The marker beside a calendar entry, by band — shared by the month page and the register's
 * year view so the two calendars cannot disagree about what a colour means.
 *
 * A DOT, not the text colour: an entry is a clickable thing, and a clickable thing is black.
 * **No amber**, because the year view sits on the INDEX page, where amber is the brand colour and
 * reads as chrome — the tones follow `<AgingStatus>`'s, with Near Expiration ORANGE.
 */
export const AGING_DOT: Record<MaintenanceAging, string> = {
  [MAINTENANCE_AGING.onSchedule]: 'bg-emerald-500',
  [MAINTENANCE_AGING.nearExpiration]: 'bg-orange-500',
  [MAINTENANCE_AGING.expired]: 'bg-red-500',
  [MAINTENANCE_AGING.expiredBeyondThreshold]: 'bg-red-800',
};

/*
  A PROJECTED occurrence — a later date the recurrence will bring round — reads as ON SCHEDULE
  (product call, 12 Oct 2026; there is no separate "Scheduled" marker). The item's CURRENT due
  date is the only entry carrying its real band. The label is the client's because the server
  sends no band on a projection, and `On Schedule` is a fixed word, not the setting's.
*/
const PROJECTED_LABEL = 'On Schedule';

/** The word an entry states — its band on the current due date, On Schedule on a projection. */
export function entryState(entry: { isProjected: boolean; agingLabel: string | null }): string {
  return entry.isProjected ? PROJECTED_LABEL : (entry.agingLabel ?? '');
}

/** The dot class for one entry. */
export function entryDot(entry: { isProjected: boolean; aging: MaintenanceAging | null }): string {
  return entry.isProjected || entry.aging == null
    ? AGING_DOT[MAINTENANCE_AGING.onSchedule]
    : AGING_DOT[entry.aging];
}
